export class ErrorMessageResource {
    public static DUPLICATED_CODE = 'financial-group:duplicated_group_code_error';
    public static EXPIRED_ENTRY_DATE_ERROR = 'financial-entry:expired_entry_date_error';
}